export default __webpack_public_path__ + "static/media/reussi.e0380a9f.svg";